import ProductRow from "./ProductRow";
import scss from "./CartTable.module.scss";
import { useTranslation } from "react-i18next";

const CartTable = ({ items, cost, showImage = true, maxHeight = "300px", setOpenDialog, translateKey }) => {
    const { t } = useTranslation();
    return (
        <>
            <table className={scss.table}>
                <colgroup>
                    <col span={1} style={{ width: "8%" }} />
                    <col span={1} style={{ width: "23%" }} />
                    <col span={1} style={{ width: "12%" }} />
                    <col span={1} style={{ width: "6%" }} />
                    <col span={1} style={{ width: "9%" }} />
                    <col span={1} style={{ width: "12%" }} />
                    <col span={1} style={{ width: "15%" }} />
                    <col span={1} style={{ width: "13%" }} />
                </colgroup>
                <thead>
                    <tr>
                        {showImage && <th className={scss.tcImage}>{t(`${translateKey}-table_th-image`)}</th>}
                        <th className={scss.tcCode}>{t(`${translateKey}-table_th-code`)}</th>
                        <th className={scss.tcTitle} width="*">
                            {t(`${translateKey}-table_th-title`)}
                        </th>
                        <th className={`${scss.rebate1} `}>{t(`${translateKey}-table_th-base_price`)}</th>
                        <th className={scss.rebate}>{t(`${translateKey}-table_th-rebate`)}</th>
                        <th className={scss.rebate}>{t(`${translateKey}-table_th-discount`)}</th>
                        <th className={scss.tcPrice}>{t(`${translateKey}-table_th-price_excluding_vat`)}</th>
                        <th className={scss.tcInt}>{t(`${translateKey}-table_th-quantity`)}</th>
                        <th className={scss.tcPrice2}>{t(`${translateKey}-table_th-total_excluding_vat`)}</th>
                        <th className={scss.tcActions} />
                    </tr>
                </thead>
                <tbody style={{ maxHeight: maxHeight, borderColor: "transparent", borderStyle: "solid", borderWidth: "2px" }}>
                    {items.map((item) => (
                        <ProductRow translateKey={translateKey} max={+item?.product?.inventory?.amount} key={item.product.id} item={item} showImage={showImage} setOpenDialog={setOpenDialog} />
                    ))}
                    {/* Show total cost */}
                </tbody>
            </table>
        </>
    );
};

export default CartTable;
